import React from 'react';

const variants = {
  accent: { background: 'var(--accent)', color: 'var(--primary)', border: 'none' },
  ghost: { background: 'transparent', color: 'var(--text-muted)', border: '1.5px solid var(--border)' },
  danger: { background: 'var(--danger)', color: '#fff', border: 'none' },
  primary: { background: 'var(--primary)', color: '#fff', border: 'none' },
};

export default function Button({ variant = 'accent', children, style, ...props }) {
  return (
    <button
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
        padding: '9px 18px',
        borderRadius: 'var(--radius-xs)',
        fontFamily: 'var(--font)',
        fontSize: '0.82rem',
        fontWeight: 600,
        cursor: 'pointer',
        transition: 'all 0.2s',
        ...variants[variant],
        ...style,
      }}
      {...props}
    >
      {children}
    </button>
  );
}